module.exports = __webpack_public_path__ + "img/panier.3a72e77a.png";